export default "__VITE_ASSET__EfeEvrdi__"